// extracted by mini-css-extract-plugin
module.exports = {"hero-content":"Hero_hero-content__2CP4U","hero-image":"Hero_hero-image__2Tahk","hero-text":"Hero_hero-text__3Fsr0","hero-phrase":"Hero_hero-phrase__1HZU6"};